export const ASSIGNMENT_STATUSES = {
	CREATED: 'created',
	REJECTED: 'rejected',
	PENDING: 'pending',
	CONFIRMED: 'confirmed',
	ACTUAL: 'actual',
	UNMERGE: 'unmerge',
	LIVE: 'live',
};

export const GROUP_RECONCILIATION_STATUSES = {
	AUTO: 'auto',
	MANUAL: 'manual',
	FAILED: 'failed',
	PENDING: 'pending',
};

export const ACTION_MARKERS = {
	REASSIGN: 'REASSIGN',
	ASSIGN_ANOTHER: 'ASSIGN_ANOTHER',
	ASSIGN_TO_FULL: 'ASSIGN_TO_FULL',
};
